import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Axios } from "../../../API/Axios";
import { Pro } from "../../../API/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faCheck, faHeart, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Skeltonshow from "../../../components/website/sekelton/skelton";
import { useCart } from "../../../Context/CartChangerContext";
import PlusMinusBtn from "../../../components/website/Btns/PlusMinsBut";
import StarRating from "../../../components/website/Products/ProductCard/StarRating";
import { useLanguage } from "../../../Context/LanguageContext";
import "./singleProduct.css";

export default function SingleProduct ()
{
  const { t, dir } = useLanguage();
  const [ product, setProduct ] = useState( null );
  const [ productImages, setProductImages ] = useState( [] );
  const [ loading, setLoading ] = useState( true );
  const [ loadingCart, setLoadingCart ] = useState( false );
  const [ added, setAdded ] = useState( false );
  const [ wishlisted, setWishlisted ] = useState( false );
  const { id } = useParams();
  const { addToCart } = useCart();
  const [ count, setCount ] = useState( 1 );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect( () =>
  {
    setLoading( true );
    Axios.get( `${ Pro }/${ id }` )
      .then( ( res ) =>
      {
        if ( res.data.length > 0 )
        {
          const images = res.data[ 0 ].images.map( ( img ) => ( {
            original: img.image,
            thumbnail: img.image,
          } ) );
          setProductImages( images );
          setProduct( res.data[ 0 ] );
        }
      } )
      .catch( ( error ) => console.error( "Error fetching product images:", error ) )
      .finally( () => setLoading( false ) );
  }, [ id ] );

  async function handleSave ()
  {
    setLoadingCart( true );
    // addToCart بيتأكد بنفسه من تسجيل الدخول والمخزون على مستوى الباك اند
    const result = await addToCart( product.id, count );
    setLoadingCart( false );

    if ( !result.success )
    {
      if ( result.reason === 'auth' )
      {
        // مش مسجّل دخول — نوجّهه لصفحة الدخول ونرجّعه هنا تاني بعد ما يسجّل
        navigate( '/auth', { state: { from: location.pathname } } );
        return;
      }
      if ( result.reason === 'stock' )
      {
        alert( t( 'singleProduct.stockAlert' ) );
        return;
      }
      alert( t( 'errors.serverError' ) );
      return;
    }

    setAdded( true );
    setTimeout( () => setAdded( false ), 1600 );
  }

  return (
    <div className="sp-page">
      <Container>
        <nav className="breadcrumb-trail" aria-label="breadcrumb">
          <Link to="/">{ t( 'singleProduct.home' ) }</Link>
          <FontAwesomeIcon icon={ dir === 'rtl' ? faChevronLeft : faChevronRight } style={ { fontSize: "10px" } } />
          <span className="current">{ product ? product.title : "..." }</span>
        </nav>

        <div className="d-flex align-items-start flex-wrap gap-4">
          { loading ? (
            <>
              <div className="col-lg-5 col-md-6 col-12">
                <Skeltonshow height="320px" length="1" classes="col-12" />
                <div className="col-12 d-flex mt-2 gap-2">
                  <Skeltonshow height="80px" length="3" classes="col-4" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <Skeltonshow height="24px" length="1" classes="col-8" />
                <Skeltonshow height="200px" length="1" classes="col-lg-8 col-12 mt-3" />
              </div>
            </>
          ) : (
            <>
              <div className="col-lg-5 col-md-6 col-12 sp-gallery-wrap">
                { productImages.length > 0 ? (
                  <ImageGallery items={ productImages } showPlayButton={ false } />
                ) : (
                  <p className="text-muted">{ t( 'singleProduct.noImages' ) }</p>
                ) }
              </div>

              <div className="col-lg-6 col-md-6 col-12 sp-info">
                <h1 className="sp-title">{ product?.title }</h1>
                <StarRating rating={ product?.rating } />

                <p className="sp-about">{ product?.About }</p>
                <p className="sp-subtitle">{ product?.description }</p>

                <div className="sp-badges">
                  { product?.sale && <span className="sp-sale-badge">{ t( 'product.saleBadge' ) }</span> }
                  { product?.stock === 1 && (
                    <span className="sp-stock-alert">{ t( 'singleProduct.onlyOneLeft' ) }</span>
                  ) }
                </div>

                <div className="sp-price-block">
                  <span className="sp-price-current">{ product?.discount }$</span>
                  { product?.price && <span className="sp-price-original">{ product.price }$</span> }
                </div>

                <div className="sp-actions">
                  <PlusMinusBtn count={ count } setCount={ setCount } />

                  <button
                    className={ `sp-add-to-cart ${ added ? "is-added" : "" }` }
                    onClick={ handleSave }
                    disabled={ loadingCart }
                  >
                    <FontAwesomeIcon icon={ added ? faCheck : faCartShopping } />
                    { loadingCart
                      ? t( 'singleProduct.addingToCart' )
                      : added
                        ? t( 'singleProduct.addedToCart' )
                        : t( 'singleProduct.addToCart' ) }
                  </button>

                  <button
                    className={ `sp-wishlist-btn ${ wishlisted ? "is-active" : "" }` }
                    onClick={ () => setWishlisted( ( prev ) => !prev ) }
                    aria-label={ t( wishlisted ? 'singleProduct.wishlistRemove' : 'singleProduct.wishlistAdd' ) }
                    title={ t( wishlisted ? 'singleProduct.wishlistRemove' : 'singleProduct.wishlistAdd' ) }
                  >
                    <FontAwesomeIcon icon={ faHeart } />
                  </button>
                </div>
              </div>
            </>
          ) }
        </div>
      </Container>
    </div>
  );
}
